module.exports = __webpack_public_path__ + "static/img/btn-chat.a1f5d797.png";